'use strict';

import React, { Component } from 'react';

class MessageSvg extends Component {
  render() {
    return (
      <svg width="28px" height="23px" viewBox="0 0 28 23">
        <g id="KOP-Core-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="KOP-Core-UI---Preview" transform="translate(-178.000000, -565.000000)" fill="#848484">
                <g id="Outlined" transform="translate(176.000000, 265.000000)">
                    <g id="Outlined/UI/email" transform="translate(0.000000, 297.000000)">
                        <path d="M1.99999996,3.62499997 L1.99999996,22.65625 C1.99999996,24.1577742 3.34314571,25.375 4.99999996,25.375 L27,25.375 C28.6568543,25.375 30,24.1577742 30,22.65625 L30,3.62499997 L1.99999996,3.62499997 Z M26.27,5.43749997 L16.65,12.814375 C16.275776,13.1044545 15.724224,13.1044545 15.35,12.814375 L5.72999997,5.43749997 L26.27,5.43749997 Z M27,23.5625 L4.99999996,23.5625 C4.44771521,23.5625 3.99999996,23.1567581 3.99999996,22.65625 L3.99999996,6.48874997 L14.06,14.2009375 C15.1792814,15.0608864 16.8207186,15.0608864 17.94,14.2009375 L28,6.48874997 L28,22.65625 C28,23.1567581 27.5522848,23.5625 27,23.5625 Z" id="Style"></path>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    );
  }
}

MessageSvg.displayName = 'MessageSvg';

export default MessageSvg;



// WEBPACK FOOTER //
// ./src/components/MessageSvg.js